import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_RAF_SCORE_REQUEST: '',
  GET_RAF_SCORE_SUCCESS: '',
  GET_RAF_SCORE_FAILURE: '',

  GET_RAF_SCORE_LIST_REQUEST: '',
  GET_RAF_SCORE_LIST_SUCCESS: '',
  GET_RAF_SCORE_LIST_FAILURE: '',

  GET_RAF_SCORE_FILE_REQUEST: '',
  GET_RAF_SCORE_FILE_SUCCESS: '',
  GET_RAF_SCORE_FILE_FAILURE: '',

  GET_HISTORICAL_RAF_SCORE_REQUEST: '',
  GET_HISTORICAL_RAF_SCORE_SUCCESS: '',
  GET_HISTORICAL_RAF_SCORE_FAILURE: '',
};

types = setStoreTypeValues(types, 'eligibilityRAFScore');

export default types;
